module.exports = __webpack_public_path__ + "img/home-safe-chauffeur.b9c6c086.png";